module.exports = __webpack_public_path__ + "static/media/dieses-mal-mache-ich-alles-richtig.6a0f68eb.png";